// extracted by mini-css-extract-plugin
export var dropdownContainer = "_nt-0";
export var leftAlign = "_nt-4";
export var listItem = "_nt-2";
export var listItemWrapper = "_nt-1";
export var operationText = "_nt-3";